module.exports = __webpack_public_path__ + "img/Sending (1).c06b7262.svg";